{% block prems_discount_sales_channel_selector_content %}
    <div class="sw-condition-line-item-in-category sw-condition__condition-value">
        <sw-entity-multi-select
            :label="$tc('prems-discount-category.detail.card.salesChannelRestriction.field.titleLabel')"
            size="medium"
            entity="sales_channel"
            :entityCollection="salesChannels"
            @update:entity-collection="setSalesChannelIds"
        >
        </sw-entity-multi-select>
    </div>
{% endblock %}